import React, { Component } from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import { Row, Card, Button, Col, Pagination } from 'react-bootstrap';
import _ from 'lodash'

import * as AppActions from '../../../redux/app/actions'

class PartnersBMOContainer extends Component {
    static propTypes = {
        title: PropTypes.string,
        regions: PropTypes.array,
        countries: PropTypes.array,
        data: PropTypes.array,
        selectedData: PropTypes.object,
        onChange: PropTypes.func,
        currentpage: PropTypes.number,
        max_num_pages: PropTypes.number,
        perslot: PropTypes.number,
        isLoading: PropTypes.bool,
        onPageChange:PropTypes.func,
    };
    static defaultProps = {
        title: "",
        regions: [],
        countries: [],
        data: [],
        selectedData: {},
        onChange: null,
        currentpage: 0,
        max_num_pages: 0,
        perslot: 6,
        isLoading: false,
        onPageChange:()=>{}
    };

    _convertCountries = (arselectedRegions,ar) => {
        let ardata = [];

        let arCountries = AppActions.getRegionCountries((Array.isArray(arselectedRegions) ? arselectedRegions : [arselectedRegions]), this.props.countries);
        /*
        if (ar !== false) {
            ar.forEach(function (entry) {
                ardata.push({
                    value: entry, label: entry.node.name
                });
            });
        }*/
        if (arCountries !== false) {
            arCountries.forEach(function (entry) {
                ardata.push({
                    value: entry, label: entry.node.name
                });
            });
        }

        return ardata;
    }

    _getColSize = () => {
        let size = 6;
        let count = 0;

        if (count === 3) {
            size = 4;
        } if (count === 4) {
            size = 3;
        }
        return size;
    }

    _convertArray = (data) => {
        let perslot = this.props.perslot;
        let loop = (data.length / perslot);
        let ar = [];
        let start = 0;
        let end = ((data.length >= perslot) ? perslot : data.length);
        for (let i = 0; i < loop; i++) {
            ar.push(data.slice(start, end));
            start = end + 1;
            end = start + perslot;
            if (end > data.length) {
                end = data.length;
            }
        }
        return ar;
    }

    _checkFileType = (mimitype) => {
        let type = "";
        try {
            type = mimitype.split("/")[0];
        } catch (error) {
            type = "";
        }
        return type;
    }



    handleRegionChange = (e) => {
        if (this.props.onChange !== null) {
            if (e !== null) {
                let arCountries = AppActions.getRegionCountries((Array.isArray(e) ? e : [e]), this.props.countries);
                this.props.onChange(arCountries, "region_countries");
                this.props.onChange((Array.isArray(e) ? e : [e]), "regions");
            } else {
                this.props.onChange([], "region_countries");
                this.props.onChange([], "regions");
            }
        }
    }

    handleOnChange = (e, type) => {
        if (this.props.onChange !== null) {
            if (e !== null) {
                let data = e.map(a => a.value);
                this.props.onChange((Array.isArray(data) ? data : [data]), type)
            } else {
                this.props.onChange([], type)
            }
        }
    }

    renderHeaderMedia = (headermedia) => {
        if (headermedia !== undefined && headermedia !== false && headermedia !== null) {
            let media = headermedia;
            if (this._checkFileType(media.mime_type) === "image") {
                return (
                    <img src={media.sizes.thumbnail} className="card-img-top" />
                )
            } else if (this._checkFileType(media.mime_type) === "video") {
                return (
                    <video className="card-img-top video-container video-container-overlay" autoplay="" loop="" muted="" data-reactid=".0.1.0.0">
                        <source type="video/mp4" data-reactid=".0.1.0.0.0" src={""} />
                    </video>
                )
            }
        }
        return (
            null
        )
    }

    getPagingRange = (current, {min = 1, total = 20, length = 5} = {}) => {
        if (length > total) length = total;
      
        let start = current - Math.floor(length / 2);
        start = Math.max(start, min);
        start = Math.min(start, min + total - length);
       
        return Array.from({length: length}, (el, i) => start + i);
    }

    getPostCard = item => {
        const src = item.logo ? item.logo.sizes.logo : "";
        //const website=(item.post_type!==undefined?`/partners/${item.post_name}`:`/operators/${item.slug}`);
        const website=(item.post_type!==undefined?`/partners/${item.post_name}`:`/resources/${item.slug}`);
        return (
            <Card className="post-card mb-4" key={item.post_name}>
                <a href={website}  ><Card.Img variant="top" src={src} /></a>
                <Card.Body>
                    {/*<Card.Title><center>{item.post_title}</center></Card.Title>*/}
                    <Card.Title><center>{item.post_title}</center></Card.Title>
                </Card.Body>
            </Card>
        )
    }

    printItems = items => {
        let res = [];
        for (let i=0; i < items.length; i+=6){
            const cards = _.range(i,i+6,1)
            res.push(
                <Row key={i}>
                    {
                        cards.map( card => {
                            if (items[card]){
                                return (
                                    <Col key={card} xs={6} md={2}>
                                        {this.getPostCard(items[card])}
                                    </Col>
                                )
                            }
                        })
                    }
                </Row>
            )
        }
        return res
    }

    render = () => {
        let colsize = 6;
        const data = this.props.data
        let selectedCountries = ((this.props.selectedData.selected_countries !== null && this.props.selectedData.selected_countries !== undefined) ? this.props.selectedData.selected_countries : []);
        let selectedRegions = ((this.props.selectedData.selected_regions !== null && this.props.selectedData.selected_regions !== undefined) ? this.props.selectedData.selected_regions : []);


        let arcountries = this._convertCountries(selectedRegions,this.props.countries);
        let arRegions = this.props.regions;

        let curpage = this.props.currentpage;
        let totalpages = this.props.max_num_pages;
        const paginateLinks = this.getPagingRange(1,{min:1,total:totalpages,length:10})

        return (
            <React.Fragment>
               {/* <div className="row">
                    {(this.props.countries.length>0 && this.props.regions.length>0) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Region</label>
                                <Select isMulti options={arRegions}

                                    value={arRegions.filter(f => selectedRegions.some(item => item.key === f.key))}

                                    onChange={(e) => this.handleRegionChange(e)}
                                />
                            </div>
                        </div>
                    )}
                    {(this.props.countries.length>0 && selectedRegions.length>0) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Country</label>
                                <Select isMulti options={arcountries}
                                    value={arcountries.filter(f => selectedCountries.some(item => item.node.termTaxonomyId === f.value.node.termTaxonomyId))}
                                    onChange={(e) => this.handleOnChange(e, "countries")}
                                />
                            </div>
                        </div>
                    )}
                    </div>*/}
                <div className="row">
                    <div className="col-md-12">
                        {this.props.isLoading && (
                            <div className="text-center py-5">
                                <div className="spinner-border text-secondary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )}
                        {
                            this.printItems(data)
                        }
                        
                        {/*
                        <Row>
                            {(totalpages > 0) && (
                                <Col>
                                    <Pagination className="flex-center">
                                    <Pagination.First disabled={curpage==1} onClick={()=>this.props.onPageChange(1)}  />
                                    <Pagination.Prev disabled={curpage==1} onClick={()=>this.props.onPageChange(curpage-1)}/>
                                    
                                    {
                                        paginateLinks.map( link => {
                                            return <Pagination.Item key={link} active={link==curpage} onClick={()=>this.props.onPageChange(link)}>{link}</Pagination.Item>
                                        })
                                    }
                                    <Pagination.Next disabled={curpage==totalpages} onClick={()=>this.props.onPageChange(curpage+1)} />
                                    <Pagination.Last disabled={curpage==totalpages} onClick={()=>this.props.onPageChange(totalpages)} />
                                    </Pagination>
                              </Col>
                            )}
                        </Row>
                        */}
                       
                    </div>
                </div>
                <br/>
            </React.Fragment>
        );
    }

}


/* Export Component ==================================================================== */
export default PartnersBMOContainer;